import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild
}                                  from '@angular/core';
import { BaseComponent }           from '@core/bases/base-component/base.component';
import {
	NgbDate,
	NgbDateAdapter,
	NgbDateNativeUTCAdapter,
	NgbDateParserFormatter,
	NgbDatepickerConfig,
	NgbDatepickerI18n,
	NgbDateStruct,
	NgbInputDatepicker
}                                  from '@ng-bootstrap/ng-bootstrap';
import { PlacementArray }          from '@ng-bootstrap/ng-bootstrap/util/positioning';
import { CustomDateTimeFormatter } from '@shared/services/ngb-datepicker-custom-services/custom-date-time-formatter.service';
import { CustomDatepickerI18n }    from '@shared/services/ngb-datepicker-custom-services/custom-datepicker-i18n.service';
import {
	DateUtils,
	ObjectUtils
}                                  from '@utils/helpers';
import { takeUntil }               from 'rxjs/operators';


@Component( {
	selector: 'app-date-picker[dateInputFormat]',
	templateUrl: './date-picker.component.html',
	styleUrls: [ './date-picker.component.scss' ],
	providers: [
		NgbDatepickerConfig,
		{ provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
		{ provide: NgbDateParserFormatter, useClass: CustomDateTimeFormatter },
		{ provide: NgbDateAdapter, useClass: NgbDateNativeUTCAdapter } // for consistent handling of dates
	]
} )

export class DatePickerComponent extends BaseComponent implements OnInit {

	private _maxDate: NgbDateStruct;
	private _minDate: NgbDateStruct;

	public controlValue: Date;
	public selectedDate: NgbDateStruct;

	@Input() dateInputFormat: Intl.DateTimeFormatOptions;
	@Input() datepickerPopupPlacement: PlacementArray = 'bottom-end top-end bottom top bottom-start top-start end start';

	@Input() set date( date: Date ) {
		this.selectedDate = DateUtils.dateToNgbDateStruct( date );
	}

	@Input() set maxDate( maxDate: Date ) {
		this._maxDate = DateUtils.dateToNgbDateStruct( maxDate );
	}

	get maxDate(): NgbDateStruct {
		return this._maxDate;
	}

	@Input() set minDate( minDate: Date ) {
		this._minDate = DateUtils.dateToNgbDateStruct( minDate );
	}

	get minDate(): NgbDateStruct {
		return this._minDate;
	}

	/** Renders expanded calendar widget with drop shadow ("pop-up" version only) */
	@Input() showShadow = false;
	@Input() showDatePickerOnly = false;

	@Output() dateChange: EventEmitter<Date> = new EventEmitter();

	/** Ngb(Input)Datepicker instance with "pop-up" version of calendar widget */
	@ViewChild( 'datepickerPopup', { static: false } ) datepickerPopup: NgbInputDatepicker;

	constructor(
		private readonly _dateAdapter: NgbDateAdapter<Date>,
		private readonly _dateParserFormatter: NgbDateParserFormatter
	) {
		super();
	}

	ngOnInit(): void {
		this.uiService.languageHasChanged$
		.pipe( takeUntil( this.ngUnsubscribe ) )
		.subscribe( ( language: string ) => {
			( this._dateParserFormatter as CustomDateTimeFormatter ).formatterOptions = {
				dateFormat: this.dateInputFormat,
				locale: language
			};

			this.controlValue = this._dateAdapter.toModel( this.selectedDate );
		} );

		this.selectedDate = this.selectedDate ?? DateUtils.dateToNgbDateStruct( new Date() );
		this.controlValue = this._dateAdapter.toModel( this.selectedDate );
		this.onDateSelect();
	}

	toggle(): void {
		this.datepickerPopup.toggle();
	}

	onDateSelect( selectedDate?: NgbDate ): void {
		if ( selectedDate ) {
			if ( ObjectUtils.simpleIsEqual( selectedDate, this.selectedDate ) ) { return; }
			this.selectedDate = selectedDate;
		}
		this.dateChange.emit( this.controlValue );
	}

}
